export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-comment-video-0883c9a0fc4144f34cd9d0f8a06d0ede.svg";